import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CodeContextGroup } from '~/constants/commands'

// Define RootState locally to avoid circular import with ~/store
interface TaskFormRootState {
  taskForm: TaskFormState
}

export type ProjectSelectionOption = 'none' | 'upload' | 'codeContext' | 'mappingTable'
export type CommandGroup = CodeContextGroup | string

export interface TaskFormState {
  optionsByGroup: {
    [CodeContextGroup.DATAWEAVE]: ProjectSelectionOption
    [CodeContextGroup.INTEGRATION]: ProjectSelectionOption
    [CodeContextGroup.SAMPLE_DATA]: ProjectSelectionOption
    [key: string]: ProjectSelectionOption
  }
}

export const initialState: TaskFormState = {
  optionsByGroup: {
    [CodeContextGroup.DATAWEAVE]: 'none',
    [CodeContextGroup.INTEGRATION]: 'none',
    [CodeContextGroup.SAMPLE_DATA]: 'none',
    [CodeContextGroup.CODE_ENHANCER]: 'upload'
  }
}

export const taskFormSlice = createSlice({
  name: 'taskForm',
  initialState,
  reducers: {
    setGroupOption(
      state,
      action: PayloadAction<{
        group: CommandGroup
        option: ProjectSelectionOption
      }>
    ) {
      const { group, option } = action.payload
      state.optionsByGroup[group] = option
    },
    resetGroupOption(
      state,
      action: PayloadAction<{
        group: CommandGroup
      }>
    ) {
      const { group } = action.payload
      if (
        [
          CodeContextGroup.DATAWEAVE,
          CodeContextGroup.INTEGRATION,
          CodeContextGroup.SAMPLE_DATA
        ].includes(group as CodeContextGroup)
      ) {
        state.optionsByGroup[group] = 'none'
      } else {
        state.optionsByGroup[group] = 'upload'
      }
    }
  }
})

export const { setGroupOption, resetGroupOption } = taskFormSlice.actions

export const selectGroupOption = (group: CommandGroup) => (state: TaskFormRootState) =>
  state.taskForm.optionsByGroup[group]

export default taskFormSlice.reducer
